export const jumpToTarget = target => {
  const targetElement = target;
  const siteHeader = document.getElementById('siteHeader');
  const scrollDistance = targetElement.offsetTop - siteHeader.offsetHeight;

  window.scrollTo({
    top: scrollDistance,
    left: 0,
    behavior: 'smooth'
  });

}



// WEBPACK FOOTER //
// ./src/ktu/js/helpers/jumpToTarget.js